<template>
  <div id="app">
    <div class="wrapper">
      <!-- Sidebar  -->
      <nav id="sidebar" v-bind:class="menuClass">
        <div class="sidebar-header">
          <div class="sidebar-logo" style="position: fixed">
            <img class="logo-panel" :src="getImgUrl(logoPanel)" />
            <span class="logo-title" v-if="showAcronym">{{ acronimo.toUpperCase() }}</span>
          </div>
          <div class="sidebar-logo-collapse">
            <img class="logo-panel" :src="getImgUrl(logoMinPanel)" />
          </div>
        </div>

        <ul
          style="position: fixed; padding: 10px"
          :class="isMobile ? 'margin-left:-20px' : ''"
        >
          <li
            :class="{ active: currentPage === '/devices' }"
            v-b-toggle="'collapseDevicesSubMenu'"
            id="subMenuRotate"
            @mouseover="hoverMenu = true"
            @mouseleave="hoverMenu = false"
          >
            <router-link to="#" class="nav-link">
              <i class="fas fa-satellite-dish" style="color: #72777a!important"></i>
              <span>Dispositivos</span>
              <span
                class="devicesMenu"
                :class="{ devicesMenuHover: hoverMenu }"
              >
                <i
                  class="fas fa-angle-right"
                  style="text-align: right; color: #72777a"
                ></i>
              </span>
            </router-link>
            <!-- sublevel -->
            <b-collapse id="collapseDevicesSubMenu" v-model="devicesCollapsed">
              <ul>
                <li
                  :class="{ active: currentPage === '/devices/locations' }"
                  v-b-toggle="'collapseDevicesSubMenu'"
                >
                  <router-link to="/devices/locations" class="nav-link">
                    <i class="fas fa-map-marker-alt" style="color: #376ba2 !important"></i>
                    <span>Ubicaciones</span>
                  </router-link>
                </li>
                <li
                  :class="{ active: currentPage === '/devices/nodes' }"
                  v-b-toggle="'collapseDevicesSubMenu'"
                >
                  <router-link to="/devices/nodes" class="nav-link">
                    <i
                      class="fas fa-sitemap"
                      style="color: #376ba2 !important"
                    ></i>
                    <span>Listado de nodos</span>
                  </router-link>
                </li>
                <li
                  :class="{ active: currentPage === '/devices/nodes/config' }"
                  v-b-toggle="'collapseDevicesSubMenu'"
                  v-if="configNodesFlag &&  isUserAdmin()"
                >
                  <router-link to="/devices/nodes/config" class="nav-link">
                    <i
                      class="fas fa-tools"
                      style="color: #376ba2 !important"
                    ></i>
                    <span>Config. de nodos</span>
                  </router-link>
                </li>
                <li
                  :class="{ active: currentPage === '/devices/sensors' }"
                  v-b-toggle="'collapseDevicesSubMenu'"
                >
                  <router-link to="/devices/sensors" class="nav-link">
                    <i
                      class="fab fa-empire"
                      style="color: #376ba2 !important"
                    ></i>
                    <span>Listado de sensores</span>
                  </router-link>
                </li>
                <li
                  :class="{ active: currentPage === '/filters/status' }"
                  v-b-toggle="'collapseDevicesSubMenu'"
                  v-if="showFilter"
                >
                  <router-link to="/filters/status" class="nav-link">
                    <i
                      class="fas fa-filter"
                      style="color: #376ba2 !important"
                    ></i>
                    <span>Estado de los filtros</span>
                  </router-link>
                </li>
                <li
                  :class="{ active: currentPage === '/devices/groups' }"
                  v-b-toggle="'collapseDevicesSubMenu'"
                  v-if="advancedAnalysisFlag"
                >
                  <router-link to="/devices/groups" class="nav-link">
                    <i
                      class="fas fa-project-diagram"
                      style="color: #376ba2 !important"
                    ></i>
                    <span>Análisis avanzado</span>
                  </router-link>
                </li>
              </ul>
            </b-collapse>
          </li>
          <li
            :class="{ active: currentPage === '/dashboard' }"
            v-b-toggle="'collapseAdminSubMenu'"
            id="subMenuRotate"
            @mouseover="hoverAdminMenu = true"
            @mouseleave="hoverAdminMenu = false"
            v-if="isUserAdmin()"
          >
            >
            <router-link to="#" class="nav-link">
              <i class="fas fa-cog" style="color:#72777a!important"></i>
              <span>Administracion</span>
              <span
                class="adminMenu"
                :class="{ adminMenuHover: hoverAdminMenu }"
              >
                <i
                  class="fas fa-angle-right"
                  style="text-align: right; color: #72777a"
                ></i>
              </span>
            </router-link>
            <!-- sublevel -->
            <b-collapse id="collapseAdminSubMenu" v-model="adminCollapsed">
              <ul>
                <li
                  :class="{ active: currentPage === '/admin/settings' }"
                  v-b-toggle="'collapseAdminSubMenu'"
                  v-if="isUserAdmin()"
                >
                  <router-link to="/admin/settings" class="nav-link">
                    <i
                      class="fas fa-cogs"
                      style="color: #376ba2 !important"
                    ></i>
                    <span>Ajustes</span>
                  </router-link>
                </li>
                <li
                  :class="{ active: currentPage === '/admin/users' }"
                  v-b-toggle="'collapseAdminSubMenu'"
                  v-if="isUserAdmin()"
                >
                  <router-link to="/admin/users" class="nav-link">
                    <i
                      class="fas fa-users"
                      style="color: #376ba2 !important"
                    ></i>
                    <span>Usuarios</span>
                  </router-link>
                </li>
                <li
                  :class="{ active: currentPage === '/admin/roles' }"
                  v-b-toggle="'collapseAdminSubMenu'"
                  v-if="isUserAdmin() && rolesFlag"
                >
                  <router-link to="/admin/roles" class="nav-link">
                    <i
                      class="fas fa-user-tag"
                      style="color: #55a01e !important"
                    ></i>
                    <span>Roles</span>
                  </router-link>
                </li>
                <li
                  :class="{ active: currentPage === '/bitacora' }"
                  v-b-toggle="'collapseAdminSubMenu'"
                  v-if="isUserAdmin()"
                >
                  <router-link to="/bitacora" class="nav-link">
                    <i class="fas fa-bug" style="color: #ff9800 !important"></i>
                    <span>Depuración</span>
                  </router-link>
                </li>
              </ul>
            </b-collapse>
          </li>
          <li
            :class="{ active: currentPage === '/superset-dashboard' }"
            v-b-toggle="'collapseSupersetSubMenu'"
            id="subMenuRotate"
            @mouseover="hoverSupersetMenu = true"
            @mouseleave="hoverSupersetMenu = false"
          >
            <router-link to="#" class="nav-link">
              <i class="fas fa-chart-line" style="color: #72777a!important"></i>
              <span>Superset Dashboard</span>
              <span
                class="supersetMenu"
                :class="{ supersetMenuHover: hoverSupersetMenu }"
              >
                <i
                  class="fas fa-angle-right"
                  style="text-align: right; color: #72777a"
                ></i>
              </span>
            </router-link>
            <!-- sublevel -->
            <b-collapse id="collapseSupersetSubMenu" v-model="supersetCollapsed">
              <ul>
                <li
                  :class="{ active: currentPage === '/superset-dashboard/embed' }"
                  v-b-toggle="'collapseSupersetSubMenu'"
                >
                  <router-link to="/superset-dashboard/embed" class="nav-link">
                    <i class="fas fa-chart-pie" style="color: #376ba2 !important"></i>
                    <span>Embed Dashboard</span>
                  </router-link>
                </li>
              </ul>
            </b-collapse>
          </li>
        </ul>
        <!-- LINE SPACING -->
        <div class="creditos" v-if="!isActive">
          <p class="text-center">
            <span style="font-size: 0.75rem">
              © SID Panel v{{ sidVersion }}
            </span>
            <br />
            <span style="font-size: 0.75rem">Grupo Ingeniería Electrónica</span>
            <br />
            <span style="font-size: 0.75rem">Universidad de Sevilla</span>
          </p>
        </div>
      </nav>

      <!-- Page Content  -->
      <div id="content">
        <nav class="navbar navbar-expand-lg">
          <div class="container-fluid">
            <!-- Burger button -->
            <div id="sidebarCollapse" @click="hideSidebar">
              <hamburger-btn></hamburger-btn>
            </div>

            <div class="navbar navbar-expand-lg" style="font-weight:400; text-color: #dcdfe6; !important; opacity: 0.8" v-if="serverTime != null">
              <span class="labelServidor">Fecha del sistema:</span>
              <span class="fechaServidor">{{ serverTime }}</span>
            </div>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="nav navbar-nav ml-auto">
                <notifications-nav v-if="notificationFlag"/>
                <dropdown-user></dropdown-user>
              </ul>
            </div>
          </div>
        </nav>

        <!-- Breadcrumb -->
        <div id="breadcrumb">
          <breadcrumb-bar></breadcrumb-bar>
        </div>

        <!-- Content -->
        <div id="innerContent">
          <router-view />
        </div>
        <!-- Content -->

        <!--INIT  FOOTER -->
        <footer>
          <div align="middle">
            <a
              :href="logoCliente.link"
              target="_blank"
              :title="logoCliente.title"
            >
              <img
                class="logoFooter"
                style="height: 45px; margin-right: 100px"
                :src="getImgUrl(logoCliente.img)"
              />
            </a>
            <a
              :href="logoOrgano.link"
              target="_blank"
              :title="logoOrgano.title"
            >
              <img
                class="logoFooter"
                style="height: 50px; margin-right: 100px"
                :src="getImgUrl(logoOrgano.img)"
              />
            </a>
            <a :href="logoUS.link" target="_blank" :title="logoUS.title">
              <img
                class="logoFooter"
                style="height: 60px"
                :src="getImgUrl(logoUS.img)"
              />
            </a>
          </div>
        </footer>
        <!--END FOOTER -->
      </div>
      <!-- End wrapper -->
    </div>

    <!-- BUTTOn TO GO UP -->
    <go-to-top
      :style="activateGoTop ? 'display:block;' : 'display:none;'"
    ></go-to-top>
    <!-- BUTTOn TO GO UP -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import PanelConfigService from "@/services/PanelConfigService";
import MiscService from "@/services/MicService";
import Breadcrumb from "./components/Breadcrumb";
import Hamburger from "./components/Hamburger";
import Dropdown from "./components/Dropdown";
import Notifications from "./components/Notifications";
import UserService from "@/services/UserService";
import Settings from "@/settings.js";
import GoToTop from "@/components/common/GoToTop.vue";
import Vue from "vue";

export default {
  name: "app",
  data() {
    return {
      config: null,
      interval: null,
      serverTime: null,
      diffTime: null,
      isActive: false,
      activeClass: "active2",
      hoverMenu: false,
      hoverAdminMenu: false,
      devicesCollapsed: false,
      adminCollapsed: false,
      acronimo: null,
      logoPanel: null,
      logoOrgano: {},
      logoUS: {},
      logoCliente: {},
      logoMinPanel: null,
      showAcronym: false,
      sidVersion: "x.x.x.x",
      scrollPosition: 0,
      activateGoTop: false,
      advancedAnalysisFlag: false,
      notificationFlag: false,
      configNodesFlag: false,
      rolesFlag: false,
      window: {
        width: 0,
        height: 0,
      },
      isMobile: false,
      menuClass: "",
      showFilter: false,
      showSuperset: true,
      hoverSupersetMenu: false,
      supersetCollapsed: false,
      showSupersetDashboard: true,
    };
  },
  methods: {
    ...mapActions("notification", ["v_getLastNotificationList", "v_initNotificationCron"]),
    hideSidebar(e) {
      e.preventDefault();
      this.isActive = !this.isActive;
      this.menuClass = this.isActive ? "active" : "";
    },    

    isUserAdmin() {
      return UserService.isUserAdmin();
    },

    getImgUrl(image) {
      if(image){
         return require("@/assets/logos/" + image);
      }
    },

    handleScroll(event) {
      this.scrollPosition = window.scrollY;
    },

    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      //Resolution handler
      if (this.window.width < 800) {
        this.isMobile = true;
        this.menuClass = "d-none";
      } else {
        this.isMobile = false;
        this.menuClass = "";
      }
    },

    async retrievePanelConfig() {
      await PanelConfigService.getPanelConfig()
        .then((panelConfig) => {
          this.advancedAnalysisFlag =
            panelConfig.data.advanced_shm_analysis &&
            panelConfig.data.advanced_shm_analysis === true
              ? true
              : false;

          this.rolesFlag =
            panelConfig.data.roles_flag && panelConfig.data.roles_flag === true
              ? true
              : false;

          this.notificationFlag =
            panelConfig.data.notification_flag && panelConfig.data.notification_flag === true
              ? true
              : false;  
              
          this.configNodesFlag =
            panelConfig.data.configNodes_flag && panelConfig.data.configNodes_flag === true
              ? true
              : false;               
        })
        .catch((err) => {
          console.log("Error recuperando configuración del panel");
          console.log(err);
        });
    },

    async getServerTime() {
      // Si el tiempo está nulo lo solicitamos al servidor
      if (this.diffTime == null) {
        await MiscService.getServerDate()
          .then((response) => {
            //console.log(response.data.data)
            this.diffTime = Date.now() - new Date(response.data.data);
            //console.log (this.diffTime)
          })
          .catch((err) => {
            console.log("Error recuperando configuración hora del servidor");
            console.log(err);
          });
      // En caso contrario solicitamos la fecha actual desde la fecha
      // solicitada al servidor
      }else {
          let syncDates = Date.now() - this.diffTime;
          //console.log(diff)
          this.serverTime = Intl.DateTimeFormat(navigator.language, {
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
              year: "numeric",
              month: "numeric",
              day: "numeric",
            }).format(syncDates);
      }
    },
  },
  watch: {
    // If the scroll value is greater than the window height,
    //let's add a class to the scroll-to-top button to show it!
    scrollPosition: function (value) {
      if (value > 100) {
        return (this.activateGoTop = true);
      } else {
        return (this.activateGoTop = false);
      }
    },

    config: function(newVal, oldVal){
      this.acronimo = newVal.acronimo
      this.logoPanel = newVal.logoPanel
      this.logoOrgano = newVal.logoOrgano
      this.logoUS = newVal.logoUS
      this.logoCliente = newVal.logoCliente    
      this.showAcronym = newVal.showAcronym
      this.sidVersion = newVal.sidVersion 
      this.logoMinPanel = newVal.logoMinPanel
    }  
  },
  components: {
    "breadcrumb-bar": Breadcrumb,
    "hamburger-btn": Hamburger,
    "dropdown-user": Dropdown,
    "notifications-nav": Notifications,
    "go-to-top": GoToTop,
  },
  computed: {
    currentPage() {
      return this.$route.path;
    },
    isAlarmModuleEnabled() {
      return Vue.config.modules.alarmModuleEnabled;
    },
  },
  beforeDestroy() {
    // prevent memory leak
    clearInterval(this.interval);
  },
  async mounted() {
    // Get settings
    this.config = await Settings
    //Load default panleconfig
    this.retrievePanelConfig();
    // Event listener for scroll
    document.addEventListener("scroll", this.handleScroll);
    //Get Current URL on entrypoint at this .vue file
    let currentURL = this.$route.path;
    //Compare location to determine which submenu need to be executed
    if (
      currentURL === "/devices/locations" ||
      currentURL === "/devices/nodes" ||
      currentURL === "/devices/nodes/config" ||
      currentURL === "/devices/sensors" ||
      currentURL === "/devices/groups"
    ) {
      this.devicesCollapsed = true;
      this.hoverMenu = true;
    } else {
      this.devicesCollapsed = false;
      this.hoverMenu = false;
    }
    //Compare location to determine which submenu need to be executed
    if (
      currentURL === "/admin/settings" ||
      currentURL === "/admin/users" ||
      currentURL === "/bitacora"
    ) {
      this.adminCollapsed = true;
      this.hoverAdminMenu = true;
    } else {
      this.adminCollapsed = false;
      this.hoverAdminMenu = false;
    }

    //Hack para que se despliegue el menu si o si (administracion)
    this.adminCollapsed = true;
    this.hoverAdminMenu = true;
  },
  async created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    //Iniciamos el timer de peticion de notificaciones
    this.v_getLastNotificationList()
    this.v_initNotificationCron()
    // Crear timer desde una fecha determinada
    // update the time every second
    //await getServerTime();
    this.interval = setInterval(async () => {
      // Concise way to format time according to system locale.
      // In my case this returns "3:48:00 am"
      this.getServerTime();
    }, 1000);   
    let response = await MiscService.getAcronym()
    let acronimo = response.data.data.acronym ? response.data.data.acronym : process.env.VUE_APP_PROJECT_ACRONYM 
    this.showFilter = acronimo == 'gri';
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style>
/* devanagari */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 300;
  src: url(~@/assets/fonts/poppins/v15/pxiByp8kv8JHgFVrLDz8Z11lFc-K.woff2)
    format("woff2");
  unicode-range: U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200C-200D, U+20A8,
    U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB;
}
/* latin-ext */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 300;
  src: url(~@/assets/fonts/poppins/v15/pxiByp8kv8JHgFVrLDz8Z1JlFc-K.woff2)
    format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 300;
  src: url(~@/assets/fonts/poppins/v15/pxiByp8kv8JHgFVrLDz8Z1xlFQ.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}
/* devanagari */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  src: url(~@/assets/fonts/poppins/v15/pxiEyp8kv8JHgFVrJJbecmNE.woff2)
    format("woff2");
  unicode-range: U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200C-200D, U+20A8,
    U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB;
}
/* latin-ext */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  src: url(~@/assets/fonts/poppins/v15/pxiEyp8kv8JHgFVrJJnecmNE.woff2)
    format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  src: url(~@/assets/fonts/poppins/v15/pxiEyp8kv8JHgFVrJJfecg.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}
/* devanagari */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  src: url(~@/assets/fonts/poppins/v15/pxiByp8kv8JHgFVrLGT9Z11lFc-K.woff2)
    format("woff2");
  unicode-range: U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200C-200D, U+20A8,
    U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB;
}
/* latin-ext */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  src: url(~@/assets/fonts/poppins/v15/pxiByp8kv8JHgFVrLGT9Z1JlFc-K.woff2)
    format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  src: url(~@/assets/fonts/poppins/v15/pxiByp8kv8JHgFVrLGT9Z1xlFQ.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}
/* devanagari */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  src: url(~@/assets/fonts/poppins/v15/pxiByp8kv8JHgFVrLEj6Z11lFc-K.woff2)
    format("woff2");
  unicode-range: U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200C-200D, U+20A8,
    U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB;
}
/* latin-ext */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  src: url(~@/assets/fonts/poppins/v15/pxiByp8kv8JHgFVrLEj6Z1JlFc-K.woff2)
    format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  src: url(~@/assets/fonts/poppins/v15/pxiByp8kv8JHgFVrLEj6Z1xlFQ.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}
/* devanagari */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  src: url(~@/assets/fonts/poppins/v15/pxiByp8kv8JHgFVrLCz7Z11lFc-K.woff2)
    format("woff2");
  unicode-range: U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200C-200D, U+20A8,
    U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB;
}
/* latin-ext */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  src: url(~@/assets/fonts/poppins/v15/pxiByp8kv8JHgFVrLCz7Z1JlFc-K.woff2)
    format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  src: url(~@/assets/fonts/poppins/v15/pxiByp8kv8JHgFVrLCz7Z1xlFQ.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

body {
  background-color: #f5f5f5 !important;
  font-family: "Poppins", sans-serif;
  background: #fafafa;
  font-size: 15px;
}

p {
  font-family: "Poppins", sans-serif;
  font-size: 1em;
  font-weight: 300;
  line-height: 1.7em;
  color: #999;
}

a,
a:hover,
a:focus {
  color: inherit;
  text-decoration: none;
  transition: all 0.3s;
}

.active2 {
  color: #393a3c;
  background-color: #f8f9fa;
  transition: all 0.25s;
}

#breadcrumb {
  display: flex;
  padding: 3px 5px 5px 27px;
  height: 30px;
  background: #fff;
  border-bottom: 2px solid rgba(0, 0, 0, 0.0625);
  border-radius: 0;
  margin-bottom: 0px;
  font-size: 13px;
  transition: all 0.2s ease;
  z-index: 800;
}

.navbar {
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 0;
  padding: 0;
  margin-bottom: 0px;
  transition: all 0.2s ease;
  z-index: 800;
  height: 57px;
}

.navbar-btn {
  box-shadow: none;
  outline: none !important;
  border: none;
}

.line {
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed #ddd;
  margin: 40px 0;
}

i,
span {
  display: inline-block;
}

/* ---------------------------------------------------
    SIDEBAR STYLE
----------------------------------------------------- */

.wrapper {
  display: flex;
  align-items: stretch;
}

.sidebar-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 5px 0px 5px;
}

.sidebar-logo-collapse {
  display: none;
  align-items: center;
  justify-content: center;
  padding: 5px 5px 0px 5px;
  /* Height added afterwards. Delete if problems in alignment */
  height: 40px;
}

.logo-panel {
  /*height:26px;*/
  height: 40px;
}

.logo-title {
  padding-left: 15px;
  font-size: 1.2em;
  font-weight: bold;
  color: #000;
}

#sidebar {
  min-width: 250px;
  max-width: 250px;
  background: #fff;
  color: #fff;
  z-index: 1000;
  bottom: 0;
  transition: all 0.3s;
  border-right: 1px solid rgba(0, 0, 0, 0.0625);
}

footer {
  background-color: #fff;
  padding: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.0625);
  transition: 0.3s;
}

#sidebarCollapse {
  cursor: pointer;
}

#sidebar.active {
  min-width: 80px;
  max-width: 80px;
  text-align: center;
}

#sidebar.active .sidebar-header h3,
#sidebar.active .CTAs {
  display: none;
}

#sidebar.active .sidebar-header strong {
  display: block;
}

#sidebar ul li a {
  text-align: left;
}

#sidebar.active ul li a {
  padding: 20px 10px;
  text-align: center;
}

#sidebar.active ul li a i {
  margin-right: 0;
  display: block;
  font-size: 1.8em;
  margin-bottom: 5px;
}

#sidebar.active ul ul a {
  padding: 10px !important;
}

#sidebar.active .dropdown-toggle::after {
  top: auto;
  bottom: 10px;
  right: 50%;
  -webkit-transform: translateX(50%);
  -ms-transform: translateX(50%);
  transform: translateX(50%);
}

#sidebar.active .sidebar-header .sidebar-logo {
  display: none;
}

#sidebar.active .sidebar-header .sidebar-logo-collapse {
  display: flex;
}

#sidebar .sidebar-header {
  background: #fff;
  height: 57px;
  display: flex;
  justify-content: center;
}

.sidebar-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.0625);
}

#sidebar .sidebar-header strong {
  display: none;
  font-size: 1em;
  color: #000;
}

#sidebar ul.components {
  align-content: left;
}

#sidebar ul li a {
  color: #72777a;
  padding: 10px;
  font-size: 0.9em !important;
  display: block;
  padding-left: 25px !important;
}

#sidebar ul li a svg {
  min-width: 20px;
  min-height: 10px;
}

#sidebar ul li a span {
  display: inline;
  margin-left: 10px;
}

#sidebar.active ul li a span {
  display: none;
  margin-left: 0px;
}

/*FIX para que resetee el margin */
#sidebar.active ul li a {
  margin-left: 0px;
}

#sidebar ul li a:hover {
  color: #393a3c;
  background-color: #f8f9fa;
  text-decoration: none;
}

#sidebar ul li a i {
  margin-right: 10px;
}

#sidebar ul li.active > a,
a[aria-expanded="true"] {
  color: #393a3c;
  background-color: #f8f9fa;
}

a[data-toggle="collapse"] {
  position: relative;
}

.dropdown-toggle::after {
  display: block;
  position: absolute;
  top: 50%;
  right: 20px;
}

ul ul a {
  font-size: 0.9em !important;
  padding-left: 30px !important;
  /*background: #6d7fcc;*/
}

.devicesMenu {
  float: right;
  padding-right: 10px;
  transition: 0.3s;
}

.devicesMenuHover {
  transition: 0.3s;
  transform: rotate(90deg) translateX(40%) translateY(30%);
}

.adminMenu {
  float: right;
  padding-right: 10px;
  transition: 0.3s;
}
.adminMenuHover {
  transition: 0.3s;
  transform: rotate(90deg) translateX(40%) translateY(30%);
}

.creditos {
  position: fixed;
  bottom: 20px;
  width: 250px;
}
/* ---------------------------------------------------
    CONTENT STYLE
----------------------------------------------------- */

#content {
  width: 100%;
  padding: 0px 0px 0px 0px;
  min-height: 100vh;
  transition: all 0.3s;
}

#innerContent {
  min-height: calc(100vh - 170px);
  padding: 20px 20px 20px 20px;
}

#app {
  width: 100%;
  height: 100%;
}

#b-card-title {
  font-weight: bold;
  color: #72777a;
}

.vgt-wrap__footer {
  color: #72777a;
  color: transparent !important;
  border: 0px !important;
  background: transparent !important;
}

.vgt-global-search {
  color: transparent !important;
  border: 0px !important;
  background: transparent !important;
}

.vgt-table thead th {
  font-size: 12px !important;
}

table.vgt-table td {
  font-size: 12px !important;
  cursor: pointer;
}

table.vgt-table tr:hover {
  background-color: rgba(51, 68, 109, 0.03);
}

.vgt-global-search__input .vgt-wrap__footer {
  zoom: 80%;
}

.vgt-wrap__footer .footer__row-count__label {
  color: #72777a;
  font-size: 0.8rem !important;
}

.vgt-input {
  width: auto !important;
}

.vgt-wrap__footer .footer__row-count__select {
  font-size: 0.8rem !important;
  background-color: transparent;
  width: auto;
  padding: 0;
  border: 0;
  border-radius: 0;
  height: auto;
  margin-left: 8px;
  color: #72777a;
  font-weight: 100 !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding-right: 15px;
  padding-left: 5px;
  cursor: pointer !important;
}

.vgt-inner-wrap {
  border-radius: 0rem !important;
  -webkit-box-shadow: 0px 0px 0px 0px !important;
  box-shadow: 0px 0px 0px 0px !important;
}

.vgt-wrap__footer .footer__navigation {
  font-size: 0.8rem !important;
  color: #72777a;
  font-weight: 100 !important;
}

/* MAX WIDTH HOTFIX FOR DatagramsList.vue RawDatagram column*/
table.vgt-table td span {
  max-width: 350px;
}

.nodeTable {
  padding: 20px 20px 20px 20px;
}

.logoFooter {
  opacity: 0.8;
  cursor: pointer;
}

.logoFooter:hover {
  opacity: 1;
}

.labelServidor {
  font-size: 14px;
  margin-right: 10px;
}

.fechaServidor {
  font-size: 12px;
}

.navbar-collapse {
  flex-grow: 0 !important;
}
</style>
